
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9e427ee6!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BlockRow.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BlockRow.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9e427ee6!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BlockRow.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/BlockRow.vue
// module id = ./dev/src/components/BlockRow.vue
// module chunks = 0